import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { BASE_URL, RESET_PASSWORD, CHECKSECURITYCODE } from '../API';
import loginimg from '../Assets/Images/reset_img.png';
import logo from '../Assets/Images/Caduceus 512x512.gif'

function ResetPassword() {
  const { register, handleSubmit, formState: { errors }, watch } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const navigate = useNavigate();
  const watchPassword = watch('password')
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const togglePasswordVisibility1 = () => setShowPassword1(!showPassword1);
  const [isLinkValid, setIsLinkValid] = useState(true);

  const submitHandler = async (data) => {
    const urlparams = new URLSearchParams(window.location.search);
    const security_code = urlparams.get('security_code');
    try {
      await axios.post(BASE_URL + RESET_PASSWORD, {
        password: data.password,
        confirm_password: data.confirm_password,
        security_code: security_code,
        language: 'ENGLISH'
      });
      toast.success("Password reset successfully!");
      navigate('/');
    } catch (err) {
      toast.error("Failed to reset password. Please try again.");
      console.error(err);
      navigate('/forgotpassword')
    }
  };

  const fetchSecurityCode = async () => {
    const urlparams = new URLSearchParams(window.location.search);
    const security_code = urlparams.get('security_code');
    if (!security_code) {
      setIsLinkValid(false);
      toast.error('No security code provided');
      return;
    }
    try {
      const response = await axios.post(BASE_URL + CHECKSECURITYCODE, {
        security_code: security_code,
        language: 'ENGLISH',
      });
      if (response.status === 200) {
        setIsLinkValid(true);
      }
    }
    catch (error) {
      setIsLinkValid(false);
      let err = error.response?.data?.error_message || error.response?.data?.error_description || 'Invalid or expired security code';
      toast.error(err)
    }
  };

  useEffect(() => { fetchSecurityCode() }, [])

  return (
    <section className="login-section">
      <div className="container-fluid g-0">
        <Row className='row-min-h'>
          <Col lg={6} className='img-n'>
            <div className="upper-fig-main-login">
              <figure className='login-img-main'>
                <img src={loginimg} alt="Login Visual" />
              </figure>
            </div>
          </Col>
          <Col lg={6}>
            <div className="inner-login-mian">
              <div className="loginupper-right">
                <figure className='creden_page_logo'>
                  <img src={logo} alt="" className='img-fluid' />
                </figure>
                {isLinkValid ? (
                  <>
                    <h2>Reset Password</h2>
                    <p className="auth_page_sub_heading">
                      Reset Password to continue your personalized healthcare journey!
                    </p>
                    <Form onSubmit={handleSubmit(submitHandler)}>
                      <Row>
                        <Col md={12}>
                          <Form.Group controlId="formGridPassword" className="comn-class-inputs">
                            <Form.Label>New Password</Form.Label>
                            <div className="cstPassGroup">
                              <Form.Control
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Enter Your New Password"
                                autoFocus
                                {...register('password', {
                                  required: 'Please enter new password.',
                                  pattern: {
                                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&_])[A-Za-z\d@$!%*?#&_]{8,}$/,
                                    message:
                                      'New Password must be at least 8 characters long with uppercase, lowercase, number, special character, and no spaces.',
                                  },
                                })}
                              />
                              <div onClick={togglePasswordVisibility} className="eyeToggleBtn">
                                {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                              </div>
                            </div>
                            {errors.password && (
                              <span className="error">{errors.password.message}</span>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group controlId="formGridConfirmPassword" className="comn-class-inputs">
                            <Form.Label>Confirm New Password</Form.Label>
                            <div className="cstPassGroup">
                              <Form.Control
                                type={showPassword1 ? 'text' : 'password'}
                                placeholder="Confirm New Password"
                                {...register('confirm_password', {
                                  required: 'Please enter confirm new password.',
                                  validate: (value) =>
                                    value === watchPassword || 'New password and confirm new password does not match.',
                                })}
                              />
                              <div onClick={togglePasswordVisibility1} className="eyeToggleBtn">
                                {showPassword1 ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                              </div>
                            </div>
                            {errors.confirm_password && (
                              <span className="error">{errors.confirm_password.message}</span>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Button className="login-btn" type="submit">
                        Reset Password
                      </Button>
                    </Form>
                    <div className="auth-bottom-link-sec">
                      <p>
                        If you remember your password, please <Link to="/login">Login</Link>.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <h2 style={{ color: "#bb2125", fontSize: '30px' }}>Your password reset link has been expired or is invalid.</h2>
                    <div className="auth-bottom-link-sec">
                      <p>
                        Please request a new reset link <Link to="/forgotpassword">here</Link>.
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
export default ResetPassword;
